import React, { useEffect } from "react";
import MyImage from "../images/ddp.webp";
import "./About.css";
import service1 from "../images/service1.webp";
import yourimage from "../images/c1 (1).webp";
import yourimage1 from "../images/c1 (3).webp";
import yourimage2 from "../images/c1 (2).webp";
import Footer from "./Footer";
import Navbar from "./Navbar";
import OurBlog from "./Blogs";

function Aboutus() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <div className="main-box-2" style={{ marginTop: "-6%" }}>
        <div className="row">
          <div className="col-12">
            <section
              className="about-us-bg  position-relative "
              style={{
                background:
                  "radial-gradient(circle at top right, #ECA0FF88 8vw, transparent 28vw)",
              }}
            >
              <div className="container mt-2">
                <div className="row  justify-content-center align-items-center text-center  " >
                  <div className="col-12">
                    <div className="main-3">
                      <div className="position-relative overflow-hidden ">
                        <div className="about-class-box"></div>
                        <div className=" ">
                          <div className="row align-items-center ">
                            <div className="col-12 col-lg-4 col-md-6 text-md-start text-center ">
                            <h1
                                className="fw-semibold fs-md-2 fs-lg-1  abouts_excess p-2"
                                style={{
                                  // zIndex: 1000,
                                  position: "relative",
                                }}
                              >
                                Delivers Expert <br />
                                Financial Solutions <br/> for Growth.
                              </h1>

                              <div className="about-class-box-12 absolute top-3/4 left-1/2 w-12 h-24 rounded-full opacity-80 -z-10"></div>
                            </div>

                            <div className="col-12 col-md-6">
                              <div className=" text-center">
                                <img
                                  src={MyImage}
                                  alt="Hero Illustration"
                                  className="image-class"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="our-beginnings py-5"
              style={{
                background:
                "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, #FFFEF4 58%, rgba(255, 255, 255, 1) 100%)",
                position: "relative",
                overflow: "hidden",
              }}>
        
            
              <div className="container">
                <div className="card_box_2 mx-auto" style={{maxWidth:"1200px"}}>
                <div className="row justify-content-center align-items-center">
                  <div className="col-12">
                    <div className="row align-items-center">
                      <div className="col-12 col-lg-6  mb-5 mb-lg-0">
                        <div className="our-box mx-auto mx-lg-0">
                          <h4
                            className="fw-semibold mb-3 text-center text-lg-start"
                            style={{ fontSize: "32px" }}
                          >
                            Our Beginnings
                          </h4>
                          <p className="text-center text-lg-start">
                            Every big dream starts with a small step—and ours
                            was a belief: finance should fuel dreams, not fears.
                            Shubh Paisa was built to simplify loans, insurance,
                            and payments so people can focus on their future,
                            not financial hurdles.
                          </p>
                          <p className="text-center text-lg-start">
                            Pre–Approved loan now available for existing
                            customers. Kindly fill in the details below.
                            Pre–Approved loan now available for existing
                            customers. Kindly fill in the details below.
                            Pre–Approved loan now available for existing
                            customers. Kindly fill in the details below.
                            Pre–Approved loan now available for existing
                            customers. Kindly fill in the details below.
                          </p>
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 d-flex justify-content-center">
                        <img
                          src={service1}
                          className="img-box"
                          alt="Service 1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </section>

            <section
  className="our-promise py-5"
  style={{ backgroundColor: "#FFEFCA", paddingTop: "7rem", paddingBottom: "9rem" }}
>
  <div className="container">
    <div className="card_box mx-auto" style={{ maxWidth: "1150px" }}>
      <div className="row">
        <div className="col-12">
          <h4 className="fw-semibold text-center mb-4 mb-md-5" style={{ fontSize: "32px" }}>
            Our Promise in 3 Simple Points
          </h4>
        </div>

        <div className="col-12">
          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-12 col-sm-6 col-lg-4 d-flex">
              <div className="card h-100 border-0 shadow-sm rounded-4 p-4 w-100 text-center">
                <div className="card-body d-flex flex-column align-items-center">
                  <div className="card-img-container mb-3" style={{ maxWidth: "100px" }}>
                    <img
                      src={yourimage}
                      alt="Accessible Finance"
                      className="img-fluid"
                    />
                  </div>
                  <h5 className="card-title fw-semibold mb-2">Accessible Finance</h5>
                  <p className="card-text text-center">
                    We make loans simple, transparent, and hassle-free.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-12 col-sm-6 col-lg-4 d-flex">
              <div className="card h-100 border-0 shadow-sm rounded-4 p-4 w-100 text-center">
                <div className="card-body d-flex flex-column align-items-center">
                  <div className="card-img-container mb-3" style={{ maxWidth: "100px" }}>
                    <img
                      src={yourimage1}
                      alt="Smart Security"
                      className="img-fluid"
                    />
                  </div>
                  <h5 className="card-title fw-semibold mb-2">Smart Security</h5>
                  <p className="card-text text-center">
                    Insurance plans that protect what matters most.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-12 col-sm-6 col-lg-4    mx-sm-auto d-flex">
              <div className="card h-100 border-0 shadow-sm rounded-4 p-4 w-100 text-center">
                <div className="card-body d-flex flex-column align-items-center">
                  <div className="card-img-container mb-3" style={{ maxWidth: "100px" }}>
                    <img
                      src={yourimage2}
                      alt="Freedom to Pay"
                      className="img-fluid"
                    />
                  </div>
                  <h5 className="card-title fw-semibold mb-2">Freedom to Pay</h5>
                  <p className="card-text text-center">
                    Payment solutions designed for real life, not just numbers.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<section className="about-us-content py-5">
  <div className="container">
    <h3 className="text-center mb-4 mb-md-5 fw-semibold" style={{ fontSize: "32px" }}>
      About us
    </h3>
    <div className="row g-4 justify-content-center">
      <div className="col-12 col-md-6">
        <div className="content-box-1 h-100">
          <h4 className="mb-3 fw-semibold">Who are we</h4>
          <p className="mb-0">
            At Shubh Paisa, we believe that financial freedom should be a right, not a privilege.
            We are a dynamic financial solutions provider that empowers individuals, businesses,
            and families with customized loan options, secure insurance policies, and seamless payment solutions.
            <br /><br />
            With a mission to simplify financial complexities, we bring clarity, transparency,
            and convenience to every financial decision you make.
            <br /><br />
            Founded with the vision of making finance accessible to everyone, Shubh Paisa is more
            than just a service—it's a commitment to your dreams.
          </p>
        </div>
      </div>

      <div className="col-12 col-md-6">
        <div className="d-flex flex-column h-100 gap-4">
          <div className="content-box-2">
            <h4 className="mb-3 fw-semibold">Our Vision</h4>
            <p className="mb-0">
              To be the most trusted and innovative financial partner for individuals and businesses,
              revolutionizing the way people borrow, insure, and transact through technology-driven
              solutions and customer-centric services...
            </p>
          </div>
          <div className="content-box-3">
            <h4 className="mb-3 fw-semibold">Our Core Value</h4>
            <p className="mb-0">
              To be the most trusted and innovative financial partner for individuals and businesses,
              revolutionizing the way people borrow, insure, and transact through technology-driven
              solutions and customer-centric services...
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

          </div>
        </div>
      </div>
      <OurBlog />
      <Footer />
    </>
  );
}

export default Aboutus;

